module.exports = __webpack_public_path__ + "static/media/S (137).70e8aec2.jpg";